import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePassportRuntimeV2 = defineStore('passport_runtime_v2', () => {
  const openModal = ref(false)
  const editObjectId = ref(0)

  const openHandler = (objectId: number) => {
    openModal.value = true
    editObjectId.value = objectId
  }

  const closeHandler = () => {
    openModal.value = false
    editObjectId.value = 0
  }

  return {
    openModal,
    editObjectId,

    openHandler,
    closeHandler,
  }
})
